export default __webpack_public_path__ + "27bdd8e96b37d3407812c1e9b350d439.svg";